import { createAdvancedOrderProduct } from './global'

function addImageAndPriceToAdvancedOrder() {
    $(document).on('click', '.product .btn.add-to-cart-button', function () {
        const product = $(this).closest('.product')
        const image = product.find('.image img').attr('data-src')
        const price = product.find('.price.price-final').text()
        const url = product.find('.name').attr('href')
        const availability = product.find('.availability span').text().trim() || 'Dostupnosť neznáma'
        console.log(image)
        createAdvancedOrderProduct({ image, price, url, availability })
    })
}

export const transformProducts = () => {
    const products = $('.products-block .product')

    if (products.length) {
        products.each(function () {
            const product = $(this)
            addImageAndPriceToAdvancedOrder()

            // SI
            if (typeof editorLang !== 'undefined' && editorLang === 'si') {
                product.find('.add-to-cart-button').text('Dodaj v košarico')
            }
        })
    }
}

function moveDiscountToFlagAction() {
    $('.product').each(function () {
        let product = $(this)
        let discountText = product.find('.flags-extra .price-save').text().trim()

        if (discountText) {
            product.find('.flag-action').append(`${discountText}`)
            product.find('.flags-extra').remove()
        }
    })
}

export function initProducts() {
    transformProducts()
    moveDiscountToFlagAction()

    document.addEventListener('ShoptetDOMPageContentLoaded', function () {
        transformProducts()
        moveDiscountToFlagAction()
    })
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function () {
        transformProducts()
        moveDiscountToFlagAction()
    })
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', function () {
        transformProducts()
        moveDiscountToFlagAction()
    })
}
